import React from 'react';

export function Loading(props) {
  return <div>Loading...</div>;
}
